<div class="create-claims-container">
  <dxo-card [bodyHeader]="statementDetailsHeader">
    <card-body>
      <div>
        <dxo-button [text]="'Return to Billing Fancy'" (handleClick)="handleClick()"></dxo-button>
      </div>
    </card-body>
  </dxo-card>
</div>